import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Facility } from 'src/app/services/firebase-utilities.service';
import { Modality, MoveService } from 'src/app/services/move.service';
import { SharingPatientId } from '../sharing-setup/sharing-setup.component';

export interface SendTargetDialogData {
  facilities: Facility[];
  preselectedFacilityId?: string | null;
}

export interface SendTargetDialogResult {
  facilityId: string;
  modality: string;
}

@Component({
    selector: 'app-send-target-dialog',
    templateUrl: './send-target-dialog.component.html',
    styleUrls: ['./send-target-dialog.component.scss'],
    standalone: false
})
export class SendTargetDialogComponent implements OnInit {
  facilities: Facility[] = [];
  allModalities: Modality[] = [];

  selectedFacility: Facility | null = null;
  facilityModalities: Modality[] = [];
  selectedModality: Modality | null = null;
  isLoadingModalities = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SendTargetDialogData,
    private dialogRef: MatDialogRef<SendTargetDialogComponent>,
    private moveService: MoveService
  ) {}

  ngOnInit(): void {
    this.facilities = this.data.facilities || [];

    this.moveService.getModalities().subscribe({
      next: res => {
        this.allModalities = res.modalities || [];
        this.isLoadingModalities = false;

        if (this.data.preselectedFacilityId) {
          const pre = this.facilities.find(f => f.id === this.data.preselectedFacilityId);
          if (pre) {
            this.onFacilitySelected(pre);
          }
        }
      },
      error: () => {
        this.isLoadingModalities = false;
      }
    });
  }

  get selectedFacilityAsSharingPatientId(): SharingPatientId | null {
    if (!this.selectedFacility) return null;
    return { facility: this.selectedFacility.id, value: '', ownerId: '' };
  }

  get canSend(): boolean {
    return !!this.selectedFacility && !!this.selectedModality;
  }

  onFacilitySelected(facility: Facility): void {
    this.selectedFacility = facility;
    const norm = (s: string) => s.toLowerCase().replace(/[-_\s]/g, '');
    this.facilityModalities = this.allModalities.filter(
      m => norm(m.name) === norm(facility.id) || norm(m.aet || '') === norm(facility.id)
    );
    this.selectedModality = this.facilityModalities.length === 1 ? this.facilityModalities[0] : null;
  }

  onSend(): void {
    if (!this.canSend) return;
    const result: SendTargetDialogResult = {
      facilityId: this.selectedFacility!.id,
      modality: this.selectedModality!.name
    };
    this.dialogRef.close(result);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
